import { Controller } from "@hotwired/stimulus"

// Narrows a list of options to the ones whose text contains what was typed.
// The legacy filter groups did this in the browser over the options already
// on the page; the server has already applied the 50-option cap.
//
// An item may name its searchable text in data-search-text (the event
// lineup does, so a row's QR button never matches). Optional `group`
// targets hide when none of their items show, and an optional `empty`
// target shows when nothing matched, with `emptyText` ("%{query}" is
// what was typed).
export default class extends Controller {
  static targets = ["input", "item", "group", "empty"]
  static values = { emptyText: String }

  apply() {
    const query = this.inputTarget.value.trim()
    const needle = query.toLowerCase()
    let visible = 0
    this.itemTargets.forEach((item) => {
      const text = item.dataset.searchText ?? item.textContent
      const hide = needle !== "" && !text.toLowerCase().includes(needle)
      item.hidden = hide
      if (!hide) visible += 1
    })
    this.groupTargets.forEach((group) => {
      group.hidden = !this.itemTargets.some((item) => !item.hidden && group.contains(item))
    })
    if (this.hasEmptyTarget) {
      const none = needle !== "" && visible === 0
      this.emptyTarget.hidden = !none
      if (none) this.emptyTarget.textContent = (this.emptyTextValue || "No matches for “%{query}”.").replace("%{query}", query)
    }
  }
}
